// Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import TimelineMax from 'gsap/TimelineMax';
import TweenLite from 'gsap/TweenLite';
import { Power4 } from 'gsap/easing/EasePack';
import 'gsap/plugins/CSSPlugin';
// Components
import Button from '../components/button';
// Actions
import toggleTimeline from '../actions/timeline';
import { setTheme } from '../actions/themes';

class Landing extends Component {
  constructor() {
    super();

    this.nextPageLocation = '/questions';
    this.tl = new TimelineMax({
      paused: false
    });

    this.state = {
      finishedTextAnimation: false
    };
  }

  componentWillMount() {
    this.props.dispatch(toggleTimeline(false));
    this.props.dispatch(setTheme('default'));

    this.animateIntroSequence = this.animateIntroSequence.bind(this);
    this.getLengthOfPath = this.getLengthOfPath.bind(this);
  }

  componentDidMount() {
    this.animateIntroSequence();
  }


  getLengthOfPath(path) {
    const length = Math.ceil(path.getTotalLength());
    return length;
  }

  handleLeaveClick = (e) => {
    e.preventDefault();

    TweenLite.to(this.$view, 0.8, {
      opacity: 0,
      delay: 0.4,
      onComplete: () => {
        this.props.router.push(this.nextPageLocation);
      }
    });
  }

  animateIntroSequence() {
    this.mariahLetters = [
      this.mariahM,
      this.mariahAOne,
      this.mariahR,
      this.mariahI,
      this.mariahATwo,
      this.mariahH
    ];

    this.messiahLetters = [
      this.messiahM,
      this.messiahE,
      this.messiahEHorizontal,
      this.messiahSOne,
      this.messiahSTwo,
      this.messiahI,
      this.messiahA,
      this.messiahAHorizontal,
      this.messiahHLeft,
      this.messiahHRight,
      this.messiahHHorizontal
    ];

    this.introSteps = [
      this.stepOneWrap,
      this.stepTwoWrap,
      this.stepThreeWrap
    ];

    this.introStepItems = [
      this.stepOneText,
      this.stepOneBtn,
      this.stepTwoText,
      this.stepTwoBtn
    ];

    this.ctaItems = [
      this.ctaLabel,
      this.ctaButton
    ];

    this.baseAnimLength = 0.7;
    this.mariahDraw = 0.4;
    this.mariahOffset = 0.35;
    this.messiahOffset = 0.45;

    // Hide all three step wrappers
    this.introSteps.forEach(step => {
      this.tl.set(step, {
        autoAlpha: 0
      });
    });

    // Hide and move down all intro step items
    this.introStepItems.forEach(stepItem => {
      this.tl.set(stepItem, {
        autoAlpha: 0,
        yPercent: 7.5
      });
    });

    this.tl.set(this.handsMariah, {
      xPercent: -100
    });

    this.tl.set(this.handsMessiah, {
      xPercent: 100
    });

    // Hide and move down the Mariah letters
    this.mariahLetters.forEach(letter => {
      this.tl.set(letter, {
        autoAlpha: 0,
        yPercent: 75
      });
    });

    // Hide and move up the Messiah letters
    this.messiahLetters.forEach(letter => {
      this.tl.set(letter, {
        strokeDasharray: this.getLengthOfPath(letter),
        strokeDashoffset: this.getLengthOfPath(letter),
        yPercent: -20
      });
    });

    // Hide and move down the CTA items
    this.ctaItems.forEach(item => {
      this.tl.set(item, {
        autoAlpha: 0,
        yPercent: 10,
        ease: Power4.easeOut
      });
    });

    // The intro text animation timeline
    this.tl
    .set(this.stepOneWrap, {
      autoAlpha: 1
    })
    .to(this.stepOneText, this.baseAnimLength, {
      autoAlpha: 1,
      yPercent: 0,
      ease: Power4.easeOut
    }, '=+1')
    .to(this.stepOneBtn, this.baseAnimLength, {
      autoAlpha: 1,
      yPercent: 0,
      ease: Power4.easeOut
    }, '-=0.5')
    .addLabel('stepOneLabel')
    .to(this.stepOneText, this.baseAnimLength, {
      delay: 0.2,
      autoAlpha: 0,
      yPercent: -5,
      ease: Power4.easeOut
    })
    .to(this.stepOneBtn, this.baseAnimLength, {
      delay: 0.2,
      autoAlpha: 0,
      yPercent: -25,
      ease: Power4.easeOut
    }, '-=0.5')
    .set(this.stepOneWrap, {
      autoAlpha: 0
    })
    .set(this.stepTwoWrap, {
      autoAlpha: 1
    })
    .to(this.stepTwoText, this.baseAnimLength, {
      autoAlpha: 1,
      yPercent: 0,
      ease: Power4.easeOut
    })
    .to(this.stepTwoBtn, this.baseAnimLength, {
      delay: 0.2,
      autoAlpha: 1,
      yPercent: 0,
      ease: Power4.easeOut
    })
    .addLabel('stepTwoLabel')
    .to(this.stepTwoText, this.baseAnimLength, {
      delay: 0.2,
      autoAlpha: 0,
      yPercent: -5,
      ease: Power4.easeOut
    })
    .to(this.stepTwoBtn, this.baseAnimLength, {
      autoAlpha: 0,
      ease: Power4.easeOut
    }, '-=0.5')
    .set(this.stepTwoWrap, {
      autoAlpha: 0
    })
    .to(this.stepThreeWrap, this.baseAnimLength, {
      autoAlpha: 1,
      ease: Power4.easeOut
    });

    // Animate the Mariah letters
    this.mariahLetters.forEach(letter => {
      this.tl.to(letter, this.mariahDraw, {
        autoAlpha: 1,
        yPercent: 0,
        ease: Power4.easeOut
      }, `-=${this.mariahOffset}`);
    });

    // Animate the Messiah letters
    this.messiahLetters.forEach(letter => {
      this.tl.to(letter, this.baseAnimLength, {
        strokeDashoffset: 0,
        yPercent: 0,
        ease: Power4.easeOut
      }, `-=${this.messiahOffset}`);
    });

    // Animate the CTA items
    this.ctaItems.forEach(item => {
      this.tl.to(item, 0.7, {
        autoAlpha: 1,
        yPercent: 0,
        ease: Power4.easeOut
      }, '-=0.5');
    });

    // Animate Mariah's hand
    this.tl.to(this.handsMariah, 1, {
      xPercent: 0,
      ease: Power4.easeOut
    }, '-=0.5');

    // Animate Messiah's hand
    this.tl.to(this.handsMessiah, 1, {
      xPercent: 0,
      ease: Power4.easeOut
    }, '-=0.8')
    .addLabel('stepThreeLabel');

    this.tl.tweenTo('stepOneLabel');
  }

  render() {
    return (
      <div className="view view--landing" ref={ref => { this.$view = ref; }}>
        <div
          ref={ref => { this.stepOneWrap = ref; }}
          className="step step--1"
        >
          <p
            className="p--big"
            ref={ref => { this.stepOneText = ref; }}
          >When you REALLY think about it, Christmas is about two people: Jesus Christ and Mariah Carey. One is the son of God, the other is an American singer with 8 Jack Russells and a 5 octave range.</p>

          <div
            className="step__button-wrap"
            ref={ref => { this.stepOneBtn = ref; }}
          >
            <Button
              className="button--pink"
              onClick={() => { this.tl.tweenTo('stepTwoLabel'); }}
            >
              Next
            </Button>
          </div>
        </div>
        <div
          ref={ref => { this.stepTwoWrap = ref; }}
          className="step step--2"
        >
          <p
            ref={ref => { this.stepTwoText = ref; }}
            className="p--big"
          >
            But which of these two seasonal superstars is responsible for the following quotes?
          </p>
          <div
            className="step__button-wrap"
            ref={ref => { this.stepTwoBtn = ref; }}
          >
            <Button
              className="button--pink"
              onClick={() => { this.tl.tweenTo('stepThreeLabel'); }}
            >
              Next
            </Button>
          </div>
        </div>
        <div
          ref={ref => { this.stepThreeWrap = ref; }}
          className="step step--3"
        >
          <h1>
            <svg className="icon--title" style={{ enableBackground: 'new 0 0 746.2 219.9' }} version="1.1" viewBox="0 0 746.2 219.9" x="0px" y="0px" xmlSpace="preserve">
              <g>
                <polygon
                  ref={(ref) => this.mariahM = ref}
                  className="mariah-letter"
                  points="116.1,111.2 90.7,69.9 56.1,69.9 56.1,181.9 89.1,181.9 89.1,123.2 114.7,161.9 116.9,161.9 &#xA; 142.1,122.9 142.1,181.9 176.1,181.9 176.1,69.9 141.6,69.9"
                />
                <path
                  ref={(ref) => this.mariahAOne = ref}
                  className="mariah-letter"
                  d="M231.4,68.9l-48.2,113h35.4l7.9-19H267l8,19h36l-48.2-113H231.4z M257,135.9h-20.3l10.2-25.7L257,135.9z"
                />
                <path
                  ref={(ref) => this.mariahR = ref}
                  className="mariah-letter"
                  d="M418.1,108.9v-0.3c0-11.1-3.1-19.9-9.8-26.5c-8.1-8.2-20.2-12.2-36.6-12.2h-53.5v112h33v-33h11.5l22.2,33h38.9&#xA; L396.6,143C410.7,136.3,418.1,124.6,418.1,108.9z M351.1,98.9h18.9c12.4,0,15.1,6.3,15.1,11.6v0.3c0,7.4-5.5,11.1-14.9,11.1h-19.1&#xA; V98.9z"
                />
                <rect
                  ref={(ref) => this.mariahI = ref}
                  className="mariah-letter"
                  height="112"
                  width="34"
                  x="432.1"
                  y="69.9"
                />
                <path
                  ref={(ref) => this.mariahATwo = ref}
                  className="mariah-letter"
                  d="M552.9,68.9h-31.5l-48.2,113h35.4l7.9-19H557l8,19h36L553.2,69.3L552.9,68.9z M547,135.9h-20.3l10.2-25.7&#xA; L547,135.9z"
                />
                <polygon
                  ref={(ref) => this.mariahH = ref}
                  className="mariah-letter"
                  points="678.1,69.9 678.1,110.9 641.1,110.9 641.1,69.9 608.1,69.9 608.1,181.9 641.1,181.9 641.1,140.9 &#xA; 678.1,140.9 678.1,181.9 712.1,181.9 712.1,69.9"
                />
              </g>
              <g id="messiah-m">
                <clipPath id="mask-m">
                  <polygon points="99.7,84.6 112.1,104.7 112.1,51.9 -10.9,51.9 -10.9,188.9 112.1,188.9 112.1,158 98.3,137" />
                </clipPath>
                <path
                  className="messiah-path st6"
                  style={{ clipPath: 'url(#mask-m)' }}
                  ref={(ref) => this.messiahM = ref}
                  d="M4.6,179.9v-118l52,88.6l51-87v116.4"
                />
              </g>
              <g id="messiah-e">
                <clipPath id="mask-e">
                  <polygon points="176.1,132.4 206.5,132.4 206.5,0 144.2,0 144.2,69.9 176.1,69.9" />
                </clipPath>
                <g
                  className="messiah-path st4"
                  style={{ clipPath: 'url(#mask-e)' }}
                  id="E_2_"
                >
                  <path
                    id="E_1_"
                    className="messiah-path st5"
                    d="M203.1,113.4h-54.5V6.4h54.5"
                    ref={(ref) => this.messiahE = ref}
                  />
                  <path
                    id="E_horizontal"
                    className="messiah-path st5"
                    d="M149.1,54.4h41"
                    ref={(ref) => this.messiahEHorizontal = ref}
                  />
                </g>
              </g>
              <g id="messiah-s">
                <clipPath id="mask-s-1">
                  <polygon points="253.2,125.1 259.8,142.3 298.9,152.8 292.9,138.9 314.1,138.9 314.1,205.9 227.1,205.9 227.1,78.9 &#xA; 312.1,78.9 312.1,125.9" />
                </clipPath>
                <path
                  className="messiah-path st3"
                  style={{ clipPath: 'url(#mask-s-1)' }}
                  id="S" d="M302.8,96.9c0,0-11.3-11.9-31-11.9s-31.8,15-31.8,26.6s8.5,21.2,33.7,26.6c26,5.6,33.7,16.5,33.7,30.5&#xA; c0,16-14.7,27.4-35.3,27.4c-22.9,0-37.3-18.1-37.3-18.1"
                  ref={(ref) => this.messiahSOne = ref}
                />
              </g>
              <g id="messiah-s-2">
                <clipPath id="mask-s-2">
                  <path d="M396.6,143c14.2-6.7,21.6-18.4,21.6-34.1v0h10v73h-99v-129h89v38l-48.1,8c12.4,0,15.1,6.3,15.1,11.6v0.3&#xA; c0,7.4-5.5,11.1-14.9,11.1L396.6,143z" />
                </clipPath>
                <path
                  className="messiah-path st2"
                  style={{ clipPath: 'url(#mask-s-2)' }}
                  id="S_5_" d="M407.8,71.9c0,0-11.3-11.9-31-11.9c-19.7,0-31.8,15-31.8,26.6s8.5,21.2,33.7,26.6&#xA; c26,5.6,33.7,16.5,33.7,30.5c0,16-14.7,27.4-35.3,27.4c-22.9,0-37.3-18.1-37.3-18.1"
                  ref={(ref) => this.messiahSTwo = ref}
                />
              </g>
              <g id="messiah-i">
                <clipPath id="mask-i">
                  <path d="M466.1,69.9H439V16.3h27.1V69.9z" />
                </clipPath>
                <path
                  className="messiah-path st1"
                  style={{ clipPath: 'url(#mask-i)' }} id="I_2_"
                  d="M452.6,24.9v119"
                  ref={(ref) => this.messiahI = ref}
                />
              </g>
              <g id="messiah-a">
                <clipPath id="mask-a">
                  <polygon points="550.1,135.9 536.1,135.9 554.3,94 609.2,219.9 500.1,219.9 524.9,162.9 540.1,162.9" />
                </clipPath>
                <path
                  className="messiah-path"
                  style={{ clipPath: 'url(#mask-a)' }}
                  id="A" d="M508.6,212.4l45-105.7l46.6,105.8"
                  ref={(ref) => this.messiahA = ref}
                />
                <path
                  className="messiah-path"
                  style={{ clipPath: 'url(#mask-a)' }}
                  id="A_horizontal_bar" d="M582.1,173.4h-55"
                  ref={(ref) => this.messiahAHorizontal = ref}
                />
              </g>
              <g id="messiah-h">
                <clipPath id="mask-h">
                  <polygon points="672.1,110.9 650.1,110.9 650.1,40.9 758.1,40.9 758.1,168.9 649.1,168.9 649.1,140.9 672,140.9&#xA;" />
                </clipPath>
                <path
                  className="messiah-path"
                  style={{ clipPath: 'url(#mask-h)' }}
                  id="H_Left_vertical_bar"
                  d="M659.6,49.9v107"
                  ref={(ref) => this.messiahHLeft = ref}
                />
                <path
                  className="messiah-path"
                  style={{ clipPath: 'url(#mask-h)' }}
                  id="H_Right_vertical_bar"
                  d="M739.6,156.9v-107"
                  ref={(ref) => this.messiahHRight = ref}
                />
                <path
                  className="messiah-path"
                  style={{ clipPath: 'url(#mask-h)' }}
                  id="H_horizontal_bar"
                  d="M660.1,97.4h79"
                  ref={(ref) => this.messiahHHorizontal = ref}
                />
              </g>
            </svg>
          </h1>

          <div className="landing__cta">
            <span
              ref={ref => { this.ctaLabel = ref; }}
              className="landing__cta-label"
            >
              Let&apos;s play <strong>Mariah</strong> or <strong>Messiah</strong>
            </span>

            <div
              ref={ref => { this.ctaButton = ref; }}
              className="landing__cta-button-wrap"
            >
              <Button
                className="button--pink"
                to={this.nextPageLocation}
                onClick={e => { this.handleLeaveClick(e); }}
              >
                Start
              </Button>
            </div>
          </div>
        </div>
        <picture>
          <source
            srcSet={require('../../images/cutouts/mariah-default-@2x.svg')}
            media="(min-width: 900px)"
          />
          <img
            ref={(ref) => this.handsMariah = ref}
            src={require('../../images/cutouts/mariah-default.svg')}
            className="hands hands--mariah"
            alt="Mariah"
          />
        </picture>

        <picture>
          <source
            srcSet={require('../../images/cutouts/messiah-default-@2x.svg')}
            media="(min-width: 900px)"
          />
          <img
            ref={(ref) => this.handsMessiah = ref}
            src={require('../../images/cutouts/messiah-default.svg')}
            className="hands hands--messiah"
            alt="Messiah"
          />
        </picture>
      </div>
    );
  }
}

export default withRouter(connect()(Landing));



/** WEBPACK FOOTER **
 ** ./src/js/containers/landing.js
 **/